/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Liveroomoffaction3Inputs */

const en_liveroomoffaction3 = /** @type {(inputs: Liveroomoffaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open features`)
};

const de_liveroomoffaction3 = /** @type {(inputs: Liveroomoffaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionen öffnen`)
};

/**
* | output |
* | --- |
* | "Open features" |
*
* @param {Liveroomoffaction3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const liveroomoffaction3 = /** @type {((inputs?: Liveroomoffaction3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Liveroomoffaction3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_liveroomoffaction3(inputs)
	return de_liveroomoffaction3(inputs)
});
export { liveroomoffaction3 as "liveRoomOffAction" }